import RegisterBetaAccess from "./RegisterBetaAccess";

export default RegisterBetaAccess